import { useSelector, useDispatch } from "react-redux";
import { DueDateEnum } from "../../models/due-date-enum";
import { setActiveSlider } from "../../redux/actions/setSlideoutDataAction";
export const SlideoutMenuButton = (props) => {
    const handleToggleSlideoutMenu = () => {
        props.toggleSlideoutMenu(prevState => !prevState);
    }
    return (<button className="gt-slideout-menu__toggle" aria-label="Close menu" onClick={() => { handleToggleSlideoutMenu(); }}>
        <svg xmlns="http://www.w3.org/2000/svg" className="gt-mobile-only">
            <use xlinkHref="#globaltasks-svg-hamburger"></use>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" className="gt-desktop-only">
            <use xlinkHref="#globaltasks-svg-sidebar-toggle"></use>
        </svg>
    </button >);
}
export const SlideoutMenu = (props) => {
    const dueTasks = useSelector(state => state.slideoutData.dueTasks);
    const dispatch = useDispatch();
    const handleDueDateChange = (dueDateType) => {
        dispatch(setActiveSlider(dueDateType));
        //handleToggleSlideoutMenu();
    };
    const handleToggleSlideoutMenu = () => {
        props.toggleSlideoutMenu(prevState => !prevState);
    }
    return (


        <div className={`gt-slideout-menu ${props.showSlideoutMenu ? 'gt-slideout-menu--active' : ''}`}>

            <button
                className="gt-slideout-menu__close gt-desktop-only"
                aria-label="Close menu"
                onClick={() => { handleToggleSlideoutMenu(); }}
            >
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-sidebar-toggle"></use>
                </svg>
            </button>
            <button className="gt-slideout-menu__item " onClick={() => handleDueDateChange(DueDateEnum.overdueTodos)}>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-duedate-overdue"></use>
                </svg>
                Overdue
                {dueTasks.overdueTodos > 0 && <span>{dueTasks.overdueTodos}</span>}

            </button>
            <button className="gt-slideout-menu__item" onClick={() =>handleDueDateChange(DueDateEnum.todaysTodos)}>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-duedate-today"></use>
                </svg>
                Today
                {dueTasks.todaysTodos > 0 && <span>{dueTasks.todaysTodos}</span>}
            </button>
            <button className="gt-slideout-menu__item " onClick={() =>handleDueDateChange(DueDateEnum.tomorrowsTodos)}>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-duedate-tomorrow"></use>
                </svg>
                Tomorrow
                {dueTasks.tomorrowsTodos > 0 && <span>{dueTasks.tomorrowsTodos}</span>}
            </button>
            <button className="gt-slideout-menu__item " onClick={() =>handleDueDateChange(DueDateEnum.thisWeeksTodos)}>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-duedate-this-week"></use>
                </svg>
                This week
                {dueTasks.thisWeeksTodos > 0 && <span>{dueTasks.thisWeeksTodos}</span>}
            </button>
            <button className="gt-slideout-menu__item " onClick={() =>handleDueDateChange(DueDateEnum.nextWeeksTodos)}>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-duedate-next-week"></use>
                </svg>
                Next week
                {dueTasks.nextWeeksTodos > 0 && <span>{dueTasks.nextWeeksTodos}</span>}
            </button>
            <button className="gt-slideout-menu__item " onClick={() => handleDueDateChange(DueDateEnum.tasksWithNoDueDate)}
                style={{ textAlign: 'left' }}>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-duedate-no-date"></use>
                </svg>
                No due date tasks
                {dueTasks.tasksWithNoDueDate > 0 && <span>{dueTasks.tasksWithNoDueDate}</span>}
            </button>
            <button className="gt-slideout-menu__item " onClick={() => handleDueDateChange(DueDateEnum.projectsWithNoDueDate)}
                style={{textAlign: 'left'} }>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="#globaltasks-svg-duedate-no-date"></use>
                </svg>
                No due date sections
                {dueTasks.projectsWithNoDueDate > 0 && <span>{dueTasks.projectsWithNoDueDate}</span>}
            </button>
        </div>

    );
}

